import api from '../../lib/api';

type ErrorResult = {
  ok: false;
  status: number;
  message: string;
};

export type ResolveInStoreSetupCodeSuccess = {
  ok: true;
  customer_id: number;
  channel: 'in_store' | 'staff_assisted';
  purpose: 'setup' | 'password_reset';
  redirect_url: string;
  expires_in_seconds: number;
};

const extractErrorMessage = (error: any, fallback: string): string =>
  error?.response?.data?.error || fallback;

export const resolveCustomerInStoreSetupCode = async (
  code: string
): Promise<{ ok: true; data: ResolveInStoreSetupCodeSuccess } | ErrorResult> => {
  try {
    const res = await api.post<ResolveInStoreSetupCodeSuccess>(
      '/api/customer-app/login/store-setup/resolve-code',
      { code }
    );
    return { ok: true, data: res.data };
  } catch (error: any) {
    return {
      ok: false,
      status: error?.response?.status ?? 500,
      message: extractErrorMessage(error, 'Failed to open setup with this code'),
    };
  }
};
